<template>
  <div>
    <app-template />
    <div class="uk-container uk-container-large">
      <div class="injuries-header">
        <h1>Injuries</h1>
        <router-link :to="{ name: 'bookPhysio' }" class="btn btn-success book-physio-btn">
          <i class="bi bi-calendar-plus"></i> Book Physio Appointment
        </router-link>
      </div>

      <!-- Navigation Tabs -->
      <ul class="nav nav-tabs injury-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'summary' }" href="javascript:;"
            @click="activeTab = 'summary'">
            <i class="bi bi-clipboard-data"></i>
            Injury Summary
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ active: activeTab === 'rtp' }" href="javascript:;" @click="activeTab = 'rtp'">
            <i class="bi bi-activity"></i>
            Return-to-Play
            <span v-if="activeRtpCount > 0" class="rtp-badge">{{ activeRtpCount }}</span>
          </a>
        </li>
      </ul>

      <div class="tabs-wrapper">
        <!-- Injury Summary Tab -->
        <section v-show="activeTab === 'summary'" class="tab-content">
          <AcademyInjurySummaryReport @injury-selected="handleInjurySelected" />
        </section>

        <!-- RTP Dashboard Tab -->
        <section v-show="activeTab === 'rtp'" class="tab-content rtp-tab-content">
          <ReturnToPlayDashboard ref="rtpDashboard" @rtp-count-updated="updateRtpCount" />
        </section>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import AcademyInjurySummaryReport from "../../components/AcademyInjurySummaryReport";
import ReturnToPlayDashboard from "../../components/ReturnToPlayDashboard";
import AppTemplate from "../layouts/App";

export default {
  name: "Injuries",
  components: {
    AcademyInjurySummaryReport,
    ReturnToPlayDashboard,
    AppTemplate
  },
  data() {
    return {
      activeTab: 'summary',
      activeRtpCount: 0,
      userData: {
        name: "",
        userType: "",
      },
    };
  },
  created() {
    this.userData = JSON.parse(localStorage.getItem("userData")) || {};

    // Check URL hash for direct navigation
    if (window.location.hash === '#rtp') {
      this.activeTab = 'rtp';
    }
  },
  methods: {
    handleInjurySelected(injury) {
      // If an injury is selected and has an active RTP, switch to RTP tab
      if (injury && injury.rtp_phase) {
        this.activeTab = 'rtp';
      }
    },
    updateRtpCount(count) {
      this.activeRtpCount = count;
    }
  },
};
</script>

<style scoped lang="scss">
.injuries-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;

  h1 {
    margin: 0;
  }

  .book-physio-btn {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.injury-tabs {
  margin-bottom: 20px;
  border-bottom: 2px solid #e9ecef;

  .nav-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    color: #6c757d;
    border: none;
    border-bottom: 3px solid transparent;
    margin-bottom: -2px;
    font-weight: 500;
    transition: all 0.2s;

    i {
      font-size: 18px;
    }

    &:hover {
      color: #007bff;
      border-color: transparent;
      background: #f8f9fa;
    }

    &.active {
      color: #007bff;
      border-bottom-color: #007bff;
      background: transparent;
    }
  }
}

.rtp-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  background: #dc3545;
  color: white;
  border-radius: 11px;
  font-size: 12px;
  font-weight: 600;
}

.tab-content {
  padding: 0;
}

.rtp-tab-content {
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
  min-height: 400px;
}
</style>
